var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Icon } from '@els/els-react--icon';
var ELSIcon = function (_a) {
    var a11y = _a.a11y, sprite = _a.sprite, children = _a.children, props = __rest(_a, ["a11y", "sprite", "children"]);
    return (<Icon sprite={sprite} a11y={a11y || {
            name: sprite,
            description: sprite
        }} {...props}>
      {children}
    </Icon>);
};
export default ELSIcon;
